// extracted by mini-css-extract-plugin
export default {"pageFooter":"page-footer_pageFooter__KkkoL"};